/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgGlobePinBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.01 21.0394C8.15527 20.6582 6.44553 19.7522 5.07942 18.4266C3.71331 17.101 2.7469 15.4103 2.29251 13.5509C1.83812 11.6915 1.91439 9.73979 2.51247 7.92253C3.11054 6.10526 4.20586 4.49708 5.67116 3.28484C7.13645 2.0726 8.91155 1.30608 10.7902 1.07435C12.6688 0.842616 14.5739 1.15519 16.284 1.97574C17.994 2.7963 19.4389 4.09115 20.4508 5.70983C21.4626 7.32851 21.9998 9.20455 22 11.12M9.59136 20.945C8.23948 18.9363 7.33467 15.2877 7.33467 11.12C7.33467 6.95237 8.23948 3.30468 9.59136 1.29597M2.024 10.4453H10.8889M4.00073 5.048H20.0002M3.15547 15.8427H7.74706M14.4106 1.29597C15.5548 3.25216 16.2532 5.44213 16.4548 7.7062M16.1298 10.9C17.1612 10.9 18.1503 11.3234 18.8796 12.0771C19.6089 12.8308 20.0187 13.8531 20.0187 14.919C20.0187 16.8197 17.1668 21.5536 16.3481 22.8766C16.3246 22.9144 16.2923 22.9456 16.2542 22.9671C16.216 22.9887 16.1733 23 16.1298 23C16.0863 23 16.0435 22.9887 16.0054 22.9671C15.9672 22.9456 15.9349 22.9144 15.9115 22.8766C15.0927 21.5541 12.2409 16.8197 12.2409 14.919C12.2409 13.8531 12.6506 12.8308 13.3799 12.0771C14.1092 11.3234 15.0984 10.9 16.1298 10.9ZM15.5742 14.75C15.5742 14.8959 15.6328 15.0358 15.7369 15.1389C15.8411 15.2421 15.9824 15.3 16.1298 15.3C16.2771 15.3 16.4184 15.2421 16.5226 15.1389C16.6268 15.0358 16.6853 14.8959 16.6853 14.75C16.6853 14.6041 16.6268 14.4642 16.5226 14.3611C16.4184 14.2579 16.2771 14.2 16.1298 14.2C15.9824 14.2 15.8411 14.2579 15.7369 14.3611C15.6328 14.4642 15.5742 14.6041 15.5742 14.75Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgGlobePin = wrapIcon(SvgGlobePinBase);
export default SvgGlobePin;
